
import { Divider, Grid } from '@mui/material';
import React, { useState } from 'react';
import authService from '../../services/authService';
import InstituteForm from '../manage-institute/instituteForm';
import Programs from '../manage-program/programs';
import GcComposition from './gcComposition';
import CustomTabs from '../common/customTabs';
import Departments from '../manage-department/departments';
import NonTeachingDepartments from '../manage-department/nonTeachingDepartments';
import DesignationsPage from '../manage-designation/designations.page';



const SynizaHR = () => {
    const [option, setOption] = useState(null)
    const [selected, setSelected] = useState("designation")
    // let option;
    function onClick(name) {
        //console.log("name trust info:",name);
        setSelected(name);
        setOption(getItem(name));
    }

    function getItem(name) {
        switch (name) {
            case "designation":
                return <DesignationsPage  />
            case "teachinStaff":
                return <Departments type={"TEACHING"} />
            case "nonTeachingStaff":
                return <NonTeachingDepartments type={"NON_TEACHING"} />
            case "holiday":
                return <h3 >Coming Soon</h3>
            case "leavs":
                return <h3 >Coming Soon</h3>
            default:
                break;
        }
    }

    function getTabs() {
        return [
            {
                name: "designation", label: "Designation"
            },
            {
                name: "teachinStaff", label: "Teaching Staff"
            },
            {
                name: "nonTeachingStaff", label: "Non-Teaching Staff"
            },
            {
                name: "holiday", label: "Holidays"
            },
            {
                name: "leavs", label: "Leaves"
            }
        ]
    }


    return (
        <>
            <Grid container columnSpacing={5}>
                {/* {getTabs().map(tab => <Grid item sm={4}>
                    {tab.name === selected ? <Button color='default' fullWidth variant='contained' onClick={() => onClick(tab.name)}> {tab.label} </Button> : <Button color='outlinedDefault' fullWidth variant='outlined' onClick={() => onClick(tab.name)}> {tab.label} </Button>}
                </Grid>)} */}

                <CustomTabs tabs={getTabs()} selected={selected} onClick={onClick} cols={2} />
            </Grid>
            <br />
            <Divider />
            <br />
            <Grid container item sm={12}>
                {getItem(selected)}
            </Grid>
        </>
    );
}

export default SynizaHR;